<template>
  <v-app red>
    <div class="l-login">
      <div class="l-login-form">
        <router-view></router-view>
      </div>
      <div class="l-login-info d-none d-lg-block d-none d-md-block">
        <!-- <InfoLogin /> -->
      </div>
    </div>
  </v-app>
</template>

<script>
export default {
  name: 'LayoutLogin',
  // components: {
  //     InfoLogin
  // }
}
</script>

<style>
.l-login {
  display: flex;
  justify-content: center;
  color: #fff;
}
.l-login-form {
  width: 55%;
}
.l-login-info {
  background-image: url('../../assets/images/layout/bg-login-turminha-do-sangue-iph-admin-2.png');
  background-position: center;
  background-size: cover;
  min-height: 100vh;
  width: 45%;
  padding-top: 200px;
}

@media (min-width: 1281px) {
}
@media (min-width: 1025px) and (max-width: 1280px) {
}
@media (min-width: 768px) and (max-width: 1024px) {
}
@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
}
@media (min-width: 481px) and (max-width: 767px) {
  .l-login-form {
    width: 100%;
  }
}
@media (min-width: 320px) and (max-width: 480px) {
  .l-login-form {
    width: 80%;
  }
}
</style>
